import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { dict } from "./translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "ck-lang";
const SUPPORTED = ["en", "fr", "es", "ru"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) return stored;
    const browser = (window.navigator.language || "en").slice(0, 2).toLowerCase();
    return SUPPORTED.includes(browser) ? browser : "en";
  });

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const value = useMemo(() => {
    const t = (path) => {
      const parts = path.split(".");
      let node = dict[lang];
      for (const p of parts) {
        if (node && p in node) node = node[p];
        else return path;
      }
      return node;
    };
    return { lang, setLang: setLangState, t, supported: SUPPORTED };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};
